<template>
  <div class="box">
    <Header :active="active" />
    <Banner />

    <div class="list">
      <div class="inner">
        <!-- <div style="margin-bottom: 20px">
          首页>咨询师团队><span class="titles">{{ team.name }}</span>
        </div> -->
        <div class="jiesa">咨询师介绍</div>
        <div class="forlist clearfix">
          <div style="justify-content: space-between" class="item">
            <div class="hy1">
              <div class="im"><img :src="team.img" alt="" /></div>
              <div class="names">{{ team.name }}</div>
              <div class="jobs">{{ team.job }}</div>
              <div v-html="team.introduction" class="niu"></div>
            </div>
            <div class="hy2">
              <div class="item num">
                <img src="../assets/images/30.jpg" alt="" />
                <span>【擅长方向】</span>
              </div>
              <div v-html="team.goodAt" class="iy"></div>
              <div class="item num">
                <img src="../assets/images/31.jpg" alt="" />
                <span>【咨询方式】</span>
              </div>
              <div v-html="team.type" class="iy"></div>
              <div class="item num">
                <img src="../assets/images/32.jpg" alt="" />
                <span>【培训经历】</span>
              </div>
              <div v-html="team.training" class="iy"></div>
              <div class="item num">
                <img src="../assets/images/33.jpg" alt="" />
                <span>【给来访者一句话】</span>
              </div>
              <div v-html="team.oneTalk" class="iy"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Map from "../components/map.vue";
export default {
  components: {
    Header,
    Right,
    Banner,
    Map,
  },
  data() {
    return {
      active: 1,
      team: null,
    };
  },
  computed: {},
  created() {
    document.documentElement.scrollTop = 0;
    this.team = JSON.parse(sessionStorage.getItem("team"));
    console.log(this.team);
  },
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  mounted() {},
  methods: {},
};
</script>

<style  scoped>
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
}
.list {
  padding: 25px 0 50px 0;
}
.titles {
  color: #2c87ce;
}
.forlist {
  margin-top: 36px;
}
.ym {
  font-size: 24px;
}
.user {
  display: block;
  width: 470px;
  height: 265px;
  flex-shrink: 0;
}
.niu {
  margin-top: 30px;
}
.ins {
  padding: 28px 0;
  border-top: 1px solid #f2f2f2;
}
.num {
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 30px;
}
.num img {
  display: block;
  width: 80px;
}
.iy {
  line-height: 26px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 30px;
}
.hy1 {
  width: 517px;
  overflow: hidden;
}
.hy2 {
  width: 660px;
  overflow: hidden;
}
.im {
  padding: 20px;
  border: 1px dashed #4a9ad5;
  border-radius: 50%;
  width: 285px;
  height: 285px;
  margin: 0 auto 30px;
}
.im img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.names {
  text-align: center;
  font-weight: bold;
  color: #3c93d8;
  font-size: 20px;
}
.jiesa {
  text-align: center;
  color: #3c93d8;
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 20px;
}
.jobs {
  color: #81b6e2;
  text-align: center;
  margin-top: 10px;
  font-size: 18px;
}
</style>